import { useState, useEffect } from 'react';
import api from '../../../services/api';
import './AdminSlider.css';

const REASON_LABELS = {
  illegal: 'Yasa dışı içerik',
  hate: 'Nefret söylemi',
  violence: 'Şiddet içerikli',
  copyright: 'Telif hakkı ihlali',
  spam: 'Spam',
  other: 'Diğer',
};

const STATUS_LABELS = {
  pending: 'Beklemede',
  reviewed: 'İncelendi',
  resolved: 'Çözüldü',
  dismissed: 'Reddedildi',
};

const AdminComplaints = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => { fetchComplaints(); }, []);

  const fetchComplaints = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/complaints');
      setComplaints(res.data);
    } catch { setError('Şikayetler yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      await api.put(`/api/complaints/${id}`, { status });
      setSuccess('Durum güncellendi.');
      fetchComplaints();
    } catch { setError('Güncelleme başarısız.'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Şikayeti silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/api/complaints/${id}`);
      setSuccess('Şikayet silindi.');
      fetchComplaints();
    } catch { setError('Silinemedi.'); }
  };

  const handleDeleteTimeline = async (timelineId, complaintId) => {
    if (!window.confirm('Bu zaman çizelgesini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.')) return;
    try {
      await api.delete(`/api/timelines/${timelineId}`);
      await api.put(`/api/complaints/${complaintId}`, { status: 'resolved', adminNote: 'İçerik silindi' });
      setSuccess('İçerik silindi ve şikayet çözüldü.');
      fetchComplaints();
    } catch { setError('Silme başarısız.'); }
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;

  const pendingCount = complaints.filter(c => c.status === 'pending').length;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Şikayetler ({complaints.length}) {pendingCount > 0 && <span style={{ color: '#f87171', fontSize: '0.8rem' }}>({pendingCount} beklemede)</span>}</h3>
        </div>

        {complaints.length > 0 ? (
          <div style={{ padding: '1rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {complaints.map(c => (
              <div key={c._id} style={{ padding: '1rem', backgroundColor: c.status === 'pending' ? '#374151' : '#2d3748', borderRadius: '0.5rem', borderLeft: c.status === 'pending' ? '3px solid #f87171' : '3px solid #4b5563' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem', flexWrap: 'wrap' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
                      <span style={{ fontSize: '0.7rem', padding: '0.15rem 0.5rem', borderRadius: '9999px', backgroundColor: c.status === 'pending' ? 'rgba(248,113,113,0.15)' : 'rgba(107,114,128,0.15)', color: c.status === 'pending' ? '#f87171' : '#9ca3af' }}>{STATUS_LABELS[c.status]}</span>
                      <span style={{ fontSize: '0.7rem', padding: '0.15rem 0.5rem', borderRadius: '9999px', backgroundColor: 'rgba(251,146,60,0.15)', color: '#fb923c' }}>{REASON_LABELS[c.reason]}</span>
                    </div>
                    <p style={{ color: '#f3f4f6', fontSize: '0.85rem', margin: '0 0 0.25rem 0' }}><strong>İçerik:</strong> {c.timelineTitle || 'Bilinmiyor'}</p>
                    <p style={{ color: '#d1d5db', fontSize: '0.8rem', margin: '0 0 0.25rem 0' }}>{c.description}</p>
                    <p style={{ color: '#6b7280', fontSize: '0.7rem', margin: 0 }}>
                      Bildiren: {c.reportedBy?.username || c.reporterEmail || 'Anonim'} • {new Date(c.createdAt).toLocaleDateString('tr-TR')}
                    </p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem', flexShrink: 0 }}>
                    {c.timelineUrl && <a href={c.timelineUrl} target="_blank" rel="noopener noreferrer" className="admin-slider-btn-edit" style={{ textAlign: 'center', textDecoration: 'none', display: 'block' }}>Görüntüle</a>}
                    {c.status === 'pending' && (
                      <>
                        <button className="admin-slider-btn-edit" style={{ backgroundColor: '#059669' }} onClick={() => handleUpdateStatus(c._id, 'resolved')}>Çözüldü</button>
                        <button className="admin-slider-btn-edit" style={{ backgroundColor: '#6b7280' }} onClick={() => handleUpdateStatus(c._id, 'dismissed')}>Reddet</button>
                        {c.timelineId && <button className="admin-slider-btn-delete" onClick={() => handleDeleteTimeline(c.timelineId._id || c.timelineId, c._id)}>İçeriği Sil</button>}
                      </>
                    )}
                    <button className="admin-slider-btn-delete" style={{ fontSize: '0.65rem' }} onClick={() => handleDelete(c._id)}>Kaldır</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="admin-slider-empty">Henüz şikayet yok.</div>
        )}
      </div>
    </div>
  );
};

export default AdminComplaints;
